import React from 'react';

import styled from 'styled-components';

import { hasSingleFeatureFlagChanged } from './helpers';
import {
  UserManagementFeatureFlagKeyType,
  UserManagementFeatureFlagOptionType,
  UserManagementFeatureFlagsType,
} from './types';
import UserManagementFeatureFlagsModalRow from './UserManagementFeatureFlagsModalRow';

const FlagsList = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 6px;
  max-height: 380px;
  overflow-y: auto;
  padding-right: 6px;
`;

const FlagDescription = styled.div`
  font-size: 12px;
  color: var(--text-secondary);
`;

type Props = {
  availableFlags: UserManagementFeatureFlagOptionType[];
  featureFlags: UserManagementFeatureFlagsType;
  initialFeatureFlags: UserManagementFeatureFlagsType | null;
  onFlagChange: (key: UserManagementFeatureFlagKeyType, value: boolean) => void;
};

const UserManagementFeatureFlagsModalSingleList = ({
  availableFlags,
  featureFlags,
  initialFeatureFlags,
  onFlagChange,
}: Props) => (
  <FlagsList>
    {availableFlags.map((flag) => (
      <UserManagementFeatureFlagsModalRow
        key={flag.key}
        flag={flag}
        changed={hasSingleFeatureFlagChanged(flag.key, featureFlags, initialFeatureFlags)}
        value={Boolean(featureFlags[flag.key])}
        detail={<FlagDescription>{flag.description}</FlagDescription>}
        dataTestIdPrefix="user-management-feature-flag"
        onChange={onFlagChange}
      />
    ))}
  </FlagsList>
);

export default UserManagementFeatureFlagsModalSingleList;
